/**
 * This component is used to display a player's information in a game.
 */
import React from "react";
import ProfileImageContainer from "../core/ProfileImageContainer.js";
import { Link } from "react-router-dom";

const GamePlayerSpotlight = ({
  id,
  club,
  name,
  team_name,
  backup,
  desc,
  title,
  stat,
}) => {
  return (
    <Link to={`/player/${id}`} className="mt-2 group">
      <div className="flex flex-col w-36 xxs:w-44 items-center justify-start">
        <p className="text-center leading-tight">{title}</p>
        <p className="pb-1 xs:pb-2 text-center font-light text-darken leading-tight text-xxs">{team_name}</p>
        <div className="xxs:w-28 xxs:h-28 w-24 h-24 mb-1">
          <ProfileImageContainer
            player={id}
            club={club}
            backup={backup}
            alt={name}
            extraClasses={"rounded"}
          />
        </div>
        <div className="w-full pt-1 flex flex-col items-center justify-center">
          <p className="text-center leading-tight text-xs group-hover:text-buiha-red dark:group-hover:text-dark-5 ease-in-out duration-200">
            {name}
          </p>
          <p className="px-4 text-center mt-0.5 leading-tight text-xxs font-light text-darken">
            {desc}
          </p>
          <p className="px-4 text-center mt-0.5 leading-tight text-xxs font-light text-darken">
            {stat}
          </p>
        </div>
      </div>
    </Link>
  );
};
export default GamePlayerSpotlight;
